import React from 'react';
import Dropdown from './Dropdown';
import Select from './Select';
import ActionMenu from './ActionMenu';

Dropdown.Select = Select;

function DropdownActionMenu(props) {
  return React.createElement(ActionMenu, { DropdownComponent: Dropdown, ...props });
}
DropdownActionMenu.displayName = 'DropdownActionMenu';
Dropdown.ActionMenu = DropdownActionMenu;

export {
  buildTileActionMenuOptions,
  buildTileToolbarHeaderActions,
  TILE_ACTION_MENU_MORE_ICON,
  TILE_TOOLBAR_ACTION_MENU_CLASS,
} from './tileActionMenuOptions';

export default Dropdown;
export { Dropdown, Select, ActionMenu };
